import React__default from 'react';
import { Hr, Text } from '@grandvisionhq/elements';

const DonationSummary = ({ formattedDonationAmount , label , disclaimer  })=>/*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Hr, null), /*#__PURE__*/ React__default.createElement("div", {
        className: "donation-summary"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "donation-summary__text"
    }, /*#__PURE__*/ React__default.createElement(Text, {
        className: "donation-summary__title",
        color: "text-primary"
    }, label), /*#__PURE__*/ React__default.createElement(Text, {
        variant: "caption",
        color: "text-secondary"
    }, disclaimer)), /*#__PURE__*/ React__default.createElement(Text, {
        className: "donation-summary__amount",
        color: "text-primary"
    }, formattedDonationAmount)))
;

export { DonationSummary };
//# sourceMappingURL=DonationSummary.js.map
